import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1MECH1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1hDyTZzDOhgU3c0hvxcgZFS03OApuRs_k/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1hfreBbxahgjyaORr5bUKDpzyMRLheiTd/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/153G91R_i_HPP2jeGQ9KzWxS1zmBM61-Y/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">MECH Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1MECH1;
